import type { SupportedLocale } from '@erp/shared';

export const pdfCustomFieldsTranslations = {
  de: {
    unsupportedSource:
      'Die automatische Belegausgabe unterstützt die Quellen Kunde, Beleg, Artikel und Position. Diese Quelle wird noch nicht unterstützt.',
    title: 'Zusatzfelder im PDF',
    hint: '„Im PDF anzeigen“ an der veröffentlichten Definition genügt. Neue freigegebene Felder erscheinen automatisch. PDF-Freigabe erteilt keine Portalfreigabe.',
    legacy:
      'Alte Feldauswahlen gelten als Platzierungen. Nicht ausgewählte neue Felder bleiben automatisch. Ein bisher leerer oder voreingestellt unsichtbarer Kundenblock sperrt die Standardausgabe nicht.',
    empty: 'Noch keine Zusatzfelder vorhanden.',
    security:
      'Nur öffentliche Zusatzfelder dürfen im PDF erscheinen. Ändern Sie bei Bedarf zuerst die Vertraulichkeit; eine Designerplatzierung erteilt keine Freigabe.',
    AUTO: 'Automatisch',
    HIDDEN: 'In dieser Vorlage ausgeblendet',
    manual: 'Individuell platziert',
    placement: 'Platzierung',
    item: 'An der Position',
    width: 'Breite (1–12)',
    label: 'Label anzeigen',
    hideEmpty: 'Leere Werte ausblenden',
    wrap: 'Text umbrechen',
    restore: 'Automatische Platzierung wiederherstellen',
    space: 'Die Belegdatenbox hat begrenzten Platz. Prüfen Sie lange Inhalte in der PDF-Vorschau.',
    diagnostics: 'PDF-Feldstatus',
    VISIBLE: 'Wird ausgegeben',
    EMPTY: 'Kein Wert im gespeicherten Beleg vorhanden',
    MISSING_SNAPSHOT:
      'Noch nicht in diesem Beleg gespeichert. Bei Entwürfen Kundendaten aktualisieren.',
    BLOCK_HIDDEN: 'Der ausgewählte Vorlagenbereich ist ausgeblendet',
    NOT_RELEASED: 'Nicht für externe PDF-Ausgabe freigegeben',
    NOT_APPLICABLE: 'Für diese Belegart nicht anwendbar',
    sources: {
      CUSTOMER: 'Kunde',
      DOCUMENT: 'Beleg',
      PRODUCT: 'Artikel',
      DOCUMENT_ITEM: 'Position',
    },
  },
  en: {
    unsupportedSource:
      'Automatic document output supports customer, document, product and line-item sources. This source is not yet supported.',
    title: 'PDF custom fields',
    hint: 'Enable “Show in PDF” on the published definition. Newly released fields appear automatically. PDF release does not grant portal visibility.',
    legacy:
      'Legacy selections are placements. Unselected new fields remain automatic. An empty or initially hidden customer block does not block standard output.',
    empty: 'No custom fields yet.',
    security:
      'Only public custom fields may appear in PDFs. Change confidentiality first if appropriate; designer placement cannot grant release.',
    AUTO: 'Automatic',
    HIDDEN: 'Hidden in this template',
    manual: 'Custom placement',
    placement: 'Placement',
    item: 'At the line item',
    width: 'Width (1–12)',
    label: 'Show label',
    hideEmpty: 'Hide empty values',
    wrap: 'Wrap text',
    restore: 'Restore automatic placement',
    space: 'The document details box has limited space. Check long content in the PDF preview.',
    diagnostics: 'PDF field status',
    VISIBLE: 'Included',
    EMPTY: 'No value in the saved document',
    MISSING_SNAPSHOT: 'Not yet saved in this document. For drafts, refresh customer data.',
    BLOCK_HIDDEN: 'The selected template block is hidden',
    NOT_RELEASED: 'Not released for external PDF output',
    NOT_APPLICABLE: 'Not applicable to this document type',
    sources: {
      CUSTOMER: 'Customer',
      DOCUMENT: 'Document',
      PRODUCT: 'Product',
      DOCUMENT_ITEM: 'Line item',
    },
  },
  fr: {
    unsupportedSource:
      'La sortie automatique prend en charge les sources client, document, article et ligne. Cette source n’est pas encore prise en charge.',
    title: 'Champs supplémentaires du PDF',
    hint: 'Activez « Afficher dans le PDF » dans la définition publiée. Les nouveaux champs autorisés apparaissent automatiquement. Cette autorisation ne donne aucun accès au portail.',
    legacy:
      'Les anciennes sélections deviennent des placements. Les nouveaux champs non sélectionnés restent automatiques. Un bloc client vide ou initialement masqué ne bloque pas la sortie standard.',
    empty: 'Aucun champ supplémentaire.',
    security:
      'Seuls les champs publics peuvent apparaître dans le PDF. Modifiez la confidentialité si nécessaire ; un placement ne constitue pas une autorisation.',
    AUTO: 'Automatique',
    HIDDEN: 'Masqué dans ce modèle',
    manual: 'Placement personnalisé',
    placement: 'Placement',
    item: 'Sur la ligne',
    width: 'Largeur (1–12)',
    label: 'Afficher le libellé',
    hideEmpty: 'Masquer les valeurs vides',
    wrap: 'Retour à la ligne',
    restore: 'Rétablir le placement automatique',
    space:
      'L’encadré du document a une place limitée. Vérifiez les textes longs dans l’aperçu PDF.',
    diagnostics: 'État des champs PDF',
    VISIBLE: 'Affiché',
    EMPTY: 'Aucune valeur dans le document enregistré',
    MISSING_SNAPSHOT:
      'Pas encore enregistré dans ce document. Actualisez les données client du brouillon.',
    BLOCK_HIDDEN: 'Le bloc sélectionné est masqué',
    NOT_RELEASED: 'Non autorisé pour le PDF externe',
    NOT_APPLICABLE: 'Non applicable à ce type de document',
    sources: {
      CUSTOMER: 'Client',
      DOCUMENT: 'Document',
      PRODUCT: 'Article',
      DOCUMENT_ITEM: 'Ligne',
    },
  },
  es: {
    unsupportedSource:
      'La salida automática admite las fuentes cliente, documento, artículo y posición. Esta fuente todavía no es compatible.',
    title: 'Campos adicionales del PDF',
    hint: 'Active « Mostrar en PDF » en la definición publicada. Los nuevos campos autorizados aparecen automáticamente. Esto no autoriza su visualización en el portal.',
    legacy:
      'Las selecciones anteriores se consideran ubicaciones. Los campos nuevos no seleccionados siguen siendo automáticos. Un bloque de cliente vacío u oculto inicialmente no bloquea la salida estándar.',
    empty: 'Todavía no hay campos adicionales.',
    security:
      'Solo los campos públicos pueden aparecer en PDF. Cambie la confidencialidad si procede; la ubicación en el diseñador no concede autorización.',
    AUTO: 'Automático',
    HIDDEN: 'Oculto en esta plantilla',
    manual: 'Ubicación personalizada',
    placement: 'Ubicación',
    item: 'En la posición',
    width: 'Anchura (1–12)',
    label: 'Mostrar etiqueta',
    hideEmpty: 'Ocultar valores vacíos',
    wrap: 'Ajustar texto',
    restore: 'Restablecer ubicación automática',
    space:
      'El cuadro de datos tiene espacio limitado. Revise los textos largos en la vista previa del PDF.',
    diagnostics: 'Estado de campos PDF',
    VISIBLE: 'Se muestra',
    EMPTY: 'Sin valor en el documento guardado',
    MISSING_SNAPSHOT:
      'Todavía no se ha guardado en este documento. Actualice los datos del cliente en el borrador.',
    BLOCK_HIDDEN: 'El bloque seleccionado está oculto',
    NOT_RELEASED: 'No autorizado para el PDF externo',
    NOT_APPLICABLE: 'No aplicable a este tipo de documento',
    sources: {
      CUSTOMER: 'Cliente',
      DOCUMENT: 'Documento',
      PRODUCT: 'Artículo',
      DOCUMENT_ITEM: 'Posición',
    },
  },
  tr: {
    unsupportedSource:
      'Otomatik belge çıktısı müşteri, belge, ürün ve satır kaynaklarını destekler. Bu kaynak henüz desteklenmiyor.',
    title: 'PDF ek alanları',
    hint: 'Yayımlanmış tanımda “PDF’de göster” seçeneğini açmanız yeterlidir. Yeni onaylanan alanlar otomatik görünür. PDF onayı portal görünürlüğü sağlamaz.',
    legacy:
      'Eski alan seçimleri yerleşim olarak kullanılır. Seçilmemiş yeni alanlar otomatik kalır. Boş veya başlangıçta gizli müşteri bloğu standart çıktıyı engellemez.',
    empty: 'Henüz ek alan yok.',
    security:
      'PDF’de yalnızca herkese açık ek alanlar gösterilebilir. Gerekirse önce gizlilik düzeyini değiştirin; tasarımcı yerleşimi onay sağlamaz.',
    AUTO: 'Otomatik',
    HIDDEN: 'Bu şablonda gizli',
    manual: 'Özel yerleşim',
    placement: 'Yerleşim',
    item: 'Kalemde',
    width: 'Genişlik (1–12)',
    label: 'Etiketi göster',
    hideEmpty: 'Boş değerleri gizle',
    wrap: 'Metni kaydır',
    restore: 'Otomatik yerleşimi geri yükle',
    space: 'Belge bilgi kutusunun alanı sınırlıdır. Uzun metinleri PDF önizlemesinde kontrol edin.',
    diagnostics: 'PDF alan durumu',
    VISIBLE: 'Gösterilir',
    EMPTY: 'Kayıtlı belgede değer yok',
    MISSING_SNAPSHOT: 'Henüz bu belgeye kaydedilmedi. Taslaklarda müşteri verilerini güncelleyin.',
    BLOCK_HIDDEN: 'Seçilen şablon bloğu gizli',
    NOT_RELEASED: 'Harici PDF çıktısı için onaylı değil',
    NOT_APPLICABLE: 'Bu belge türü için geçerli değil',
    sources: {
      CUSTOMER: 'Müşteri',
      DOCUMENT: 'Belge',
      PRODUCT: 'Ürün',
      DOCUMENT_ITEM: 'Kalem',
    },
  },
} satisfies Record<SupportedLocale, Record<string, string | Record<string, string>>>;
